/* screens/checkout/CheckoutLayout.jsx — узкая обёртка платёжных экранов (S11).
   Вне AppShell и Sidebar: только центрированная карточка ≤480px + логотип-ссылка
   на «/». min-height:100dvh (без фикс-высот). На xs — почти полная ширина.
   Источник: 12 §2.2. ХЕНДОФФ: → frontend/src/components/checkout/CheckoutLayout.jsx. */

import { RR } from '../../lib/router.jsx';

  const { Link } = RR;

  function CheckoutLayout({ children }) {
    return (
      <div className="checkout-layout">
        <div className="checkout-layout__inner">
          <Link to="/" className="checkout-layout__brand" aria-label="На главную Ресториум">
            <span className="brand-mark"><img src="/logo-mark.svg" alt="" /></span>
            <span className="brand-word">Ресториум</span>
          </Link>
          <div className="checkout-card">
            {children}
          </div>
          <div className="checkout-layout__foot t-caption text-mute">
            Защищённая оплата · © 2026 Ресториум
          </div>
        </div>
      </div>
    );
  }

export { CheckoutLayout };
